<by-notifications />
<router-outlet byBeddy byLinkCustom />
<div class="loader"></div>
